const appConfig = {
    apiPrefix: '/api',
    authenticatedEntryPath: '/dashboard',
    unAuthenticatedEntryPath: '/customer/wardrobe-vender',
    tourPath: '',
    enableMock: true
}

export default appConfig